import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-155ed172"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Card" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "btn-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-upload",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" })
], -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-pencil-square",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash3",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "btn-group" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-right-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" })
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-rewind-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696z" })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-skip-start-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-skip-end-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" })
], -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col align-self-end" }, null, -1))
const _hoisted_34 = { class: "container" }
const _hoisted_35 = {
  class: "row",
  style: {"gap":"20px"}
}
const _hoisted_36 = { class: "col-9 d-flex flex-column justify-content-center align-items-center" }
const _hoisted_37 = { class: "row g-3" }
const _hoisted_38 = { class: "col-md-5" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault01",
  class: "form-label"
}, "Base de Datos", -1))
const _hoisted_40 = ["readonly"]
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault04",
  class: "form-label"
}, "Tipo de Base de Datos", -1))
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { selected: "" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Informix", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Oracle", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "SQL SERVER", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "Sybase", -1))
const _hoisted_49 = { class: "col-md-6" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault03",
  class: "form-label"
}, "Servidor de Base de Datos", -1))
const _hoisted_51 = ["readonly"]
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault03",
  class: "form-label"
}, "Nombre del equipo", -1))
const _hoisted_54 = ["readonly"]
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault02",
  class: "form-label"
}, "Direccion", -1))
const _hoisted_57 = ["readonly"]
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault05",
  class: "form-label"
}, "Servicio", -1))
const _hoisted_60 = ["readonly"]
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault03",
  class: "form-label"
}, "Puerto", -1))
const _hoisted_63 = ["readonly"]
const _hoisted_64 = { class: "col-md-5" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationDefault03",
  class: "form-label"
}, "Protocolo", -1))
const _hoisted_66 = ["readonly"]
const _hoisted_67 = {
  class: "col",
  style: {"background-color":"rgba(255, 255, 255, 0.3)","backdrop-filter":"blur(10px)","border-radius":"10px"}
}
const _hoisted_68 = { class: "btn-group2" }
const _hoisted_69 = ["disabled"]
const _hoisted_70 = ["disabled"]

import { ref, computed } from 'vue';
import axios from 'axios';
import { useAlert } from '@/store/useAlert';
import { UrlGlobal } from '@/store/dominioGlobal';

export default /*#__PURE__*/_defineComponent({
  __name: 'BdSeg001',
  setup(__props) {

const {success, error, question,warning} = useAlert()
const dUrl = UrlGlobal()

//--------------------------------------------------------------------------------------------------------------
// Estado del formulario y la data
const formData = ref({
  base_datos: '',
  tipo_base_datos: '',
  servidor_bdatos: '',
  hostname: '',
  ip_address: '',
  servicio: '',
  puerto: '',
  protocolo: ''
});

// Variables de control
const dataList = ref<any[]>([]); // Lista de datos de la API
const currentIndex = ref(0);
const isEditing = ref(false);
const isSearching = ref(false);
const isInserting = ref(false);
const isDeleting = ref(false)
const canNavigate = ref(false);
const onlyRead = ref(true);
const ButtonText = ref('OK')
const ButtonText2 = ref('Cancelar')

// Deshabilita los botones de btn-group2 si no está en modo búsqueda o insercion
const canUseGroup2 = computed(() => isSearching.value || isInserting.value || isEditing.value || isDeleting.value);

//------------------------------------------------------------------------------------------------------------------

//Funciones---------------------------------------------------------------------------------------------------------
// Función para iniciar inserción
const startInsert = () => {
  isInserting.value = true;
  isSearching.value = false;
  isEditing.value = false;
  isDeleting.value = false;
  onlyRead.value = false;
  ButtonText.value = 'Insertar';
};

// Función para iniciar búsqueda
const startSearch = () => {
  isSearching.value = true;
  isInserting.value = false;
  isEditing.value = false;
  isDeleting.value = false;
  onlyRead.value = false;
};

// Funcion para iniciar edición
let pk : string
const startUpdate = () => {
  isEditing.value = true;
  isInserting.value = false;
  isSearching.value = false;
  isDeleting.value = false;
  canNavigate.value = false;
  onlyRead.value = false;
  ButtonText.value = 'Editar';
  ButtonText2.value = 'Volver';
  pk = formData.value.base_datos
};

//funcion para iniciar eliminacion
const starDelete = () => {
  isDeleting.value = true;
  isEditing.value = false;
  isInserting.value = false;
  isSearching.value = false;
  canNavigate.value = false;
  onlyRead.value = true;
  ButtonText.value = 'Eliminar';
  ButtonText2.value = 'Volver'
};

// Función para hacer la consulta
const handleSearch = async () => {
  try {
    const response = await axios.post(dUrl.urlGlobal + '/api/query', { tabla: 'segbdato', filtro: formData.value });
    dataList.value = response.data;
    currentIndex.value = 0;
    updateFormData();

    if (dataList.value.length === 0) {
      warning('No se ha encontrado registros con los datos ingresados','Vuelva hacer la consulta')
      ButtonText.value = 'Ok';
    } else {
      ButtonText.value = 'Consulta';
      canNavigate.value = true;
      onlyRead.value = true;
    }
  } catch (err:any) {
    error(err.response?.data?.detail || 'Ocurrió un error en la consulta.')
  }
};

//Funcion para la insercion
const handleInsert = async () => {
    // Mostrar confirmación
    const result = await question(
    'Se va a insertar el campo con los nuevos datos.',
    '¿Deseas insertar este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }
  
  const data = {
    model: "segbdato",
    data: {
      base_datos: formData.value.base_datos,
      tipo_base_datos: formData.value.tipo_base_datos,
      servidor_bdatos: formData.value.servidor_bdatos,
      hostname: formData.value.hostname,
      ip_address: formData.value.ip_address,
      servicio: formData.value.servicio,
      puerto: formData.value.puerto,
      protocolo: formData.value.protocolo
    }
  }
  try {
    const response = await fetch(dUrl.urlGlobal + '/api/insert/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
   
    if (response.ok) {
       success('Los datos fueron insertados correctamente.', 'Insercion exitosa')
    } else{
       error('Ocurrió un error al insertar los datos.')
    }
  } catch (err:any ) {
    error(err.response?.data?.detail || 'Ocurrió un error al insertar los datos.')
  }
}

//funcion para el update
const handleUpdate = async () => {
    // Mostrar confirmación
    const result = await question(
    'Se va a actualizar el campo con los nuevos datos.',
    '¿Deseas actualizar este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  try {
    const response = await axios.post(dUrl.urlGlobal + '/api/update/', {
      table: 'segbdato',
      filters: { base_datos: pk }, // Filtro para identificar el registro a actualizar
      data: {
        base_datos: formData.value.base_datos,
        tipo_base_datos: formData.value.tipo_base_datos,
        servidor_bdatos: formData.value.servidor_bdatos,
        hostname: formData.value.hostname,
        ip_address: formData.value.ip_address,
        servicio: formData.value.servicio,
        puerto: formData.value.puerto,
        protocolo: formData.value.protocolo
      } // Datos a actualizar
    })
    if (response.status == 200) {
        success('Los datos fueron actualizados correctamente.', 'Actualización exitosa')
    } else{
       error('Ocurrió un error al actualizar los datos.')
    }
  } catch (err:any) {
    error(err.response?.data?.detail || 'Ocurrió un error al actualizar los datos.')
  }
}

//funcion para eliminar
const handleDelete = async () => {
   // Mostrar confirmación
   const result = await question(
    '¡No podrás revertir esto!',
    '¿Deseas eliminar este registro?'
  )

  if (!result.isConfirmed) {
    // Usuario canceló, salimos de la función
    return
  }

  try {
    const response = await axios.post(dUrl.urlGlobal + '/api/delete/', {
      table: 'segbdato',
      filters: { base_datos: formData.value.base_datos }, // Filtro para identificar el registro a eliminar
    })
    if (response.status == 200) {
       success('¡Eliminado!', 'El registro ha sido eliminado con exito.')
    } else{
       error('Ocurrió un error al eliminar el registro.')
    }
  } catch (err:any) {
    error(err.response?.data?.detail || 'Ocurrió un error al eliminar el registro.')
  }
}

// Actualiza el formulario con el registro actual
const updateFormData = () => {
  if (dataList.value.length > 0) {
    formData.value = { ...dataList.value[currentIndex.value] };
  }
};
//------------------------------------------------------------------------------------------------------------------

// Navegación entre registros---------------------------------------------------------------------------------------
const goToFirst = () => {
  currentIndex.value = 0;
  updateFormData();
};
const goToPrev = () => {
  if (currentIndex.value > 0) {
    currentIndex.value--;
    updateFormData();
  }
};
const goToNext = () => {
  if (currentIndex.value < dataList.value.length - 1) {
    currentIndex.value++;
    updateFormData();
  }
};
const goToLast = () => {
  currentIndex.value = dataList.value.length - 1;
  updateFormData();
};
//------------------------------------------------------------------------------------------------------------------

// Control de botones submit y cancelar-----------------------------------------------------------------------------------------------

//boton principal que controla el submit
const toggleSearch = () => {
  if (dataList.value.length && isSearching.value == true) {
    // Si ya hay datos, "Consulta" limpia y reinicia la búsqueda
    dataList.value = [];
    formData.value = { base_datos: '', tipo_base_datos: '', servidor_bdatos: '', hostname: '', ip_address: '', servicio: '', puerto: '', protocolo: '', };
    onlyRead.value = false;
    ButtonText.value = 'Ok'
    canNavigate.value = false;
  } else if (isInserting.value == true) {
    handleInsert();
  } else if (isEditing.value == true) {
    handleUpdate();
  } else if (isDeleting.value == true) {
    handleDelete()
  }
  else {
    // Si no hay datos, hace la consulta
    handleSearch();
  }
};


// Boton que restablece todo a estado inicial
const resetAll = () => {
  if (ButtonText2.value == 'Cancelar') {
    dataList.value = [];
    formData.value = { base_datos: '', tipo_base_datos: '', servidor_bdatos: '', hostname: '', ip_address: '', servicio: '', puerto: '', protocolo: '', };
    isInserting.value = false;
    isSearching.value = false;
    isEditing.value = false;
    isDeleting.value = false;
    canNavigate.value = false;
    onlyRead.value = true;
    ButtonText.value = 'Ok'
  } else {
    dataList.value = [];
    formData.value = { base_datos: '', tipo_base_datos: '', servidor_bdatos: '', hostname: '', ip_address: '', servicio: '', puerto: '', protocolo: '', };
    startSearch()
    ButtonText.value = 'Ok'
    ButtonText2.value = 'Cancelar'
  }

};
//------------------------------------------------------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("body", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  class: "btn-insert",
                  onClick: startInsert,
                  disabled: isSearching.value || isEditing.value || isDeleting.value
                }, _hoisted_9, 8, _hoisted_7),
                _createElementVNode("button", {
                  class: "btn-search",
                  onClick: startSearch,
                  disabled: isInserting.value || isEditing.value || isDeleting.value
                }, _hoisted_12, 8, _hoisted_10),
                _createElementVNode("button", {
                  class: "btn-update",
                  onClick: startUpdate,
                  disabled: !canNavigate.value
                }, _hoisted_15, 8, _hoisted_13),
                _createElementVNode("button", {
                  class: "btn-delete",
                  onClick: starDelete,
                  disabled: !canNavigate.value
                }, _hoisted_18, 8, _hoisted_16)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn-next",
                  onClick: goToNext,
                  disabled: !canNavigate.value
                }, _hoisted_23, 8, _hoisted_21),
                _createElementVNode("button", {
                  class: "btn-prev",
                  onClick: goToPrev,
                  disabled: !canNavigate.value
                }, _hoisted_26, 8, _hoisted_24),
                _createElementVNode("button", {
                  class: "btn-skipstar",
                  onClick: goToFirst,
                  disabled: !canNavigate.value
                }, _hoisted_29, 8, _hoisted_27),
                _createElementVNode("button", {
                  class: "btn-skipend",
                  onClick: goToLast,
                  disabled: !canNavigate.value
                }, _hoisted_32, 8, _hoisted_30)
              ])
            ]),
            _hoisted_33
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("form", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.base_datos) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_40), [
                    [_vModelText, formData.value.base_datos]
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.tipo_base_datos) = $event)),
                    class: "form-select",
                    disabled: onlyRead.value
                  }, [
                    _createElementVNode("option", _hoisted_44, _toDisplayString(formData.value.tipo_base_datos), 1),
                    _hoisted_45,
                    _hoisted_46,
                    _hoisted_47,
                    _hoisted_48
                  ], 8, _hoisted_43), [
                    [_vModelSelect, formData.value.tipo_base_datos]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.servidor_bdatos) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_51), [
                    [_vModelText, formData.value.servidor_bdatos]
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.hostname) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_54), [
                    [_vModelText, formData.value.hostname]
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.ip_address) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_57), [
                    [_vModelText, formData.value.ip_address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.servicio) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_60), [
                    [_vModelText, formData.value.servicio]
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _hoisted_62,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.puerto) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_63), [
                    [_vModelText, formData.value.puerto]
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.protocolo) = $event)),
                    type: "text",
                    class: "form-control",
                    readonly: onlyRead.value
                  }, null, 8, _hoisted_66), [
                    [_vModelText, formData.value.protocolo]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: toggleSearch,
                  disabled: !canUseGroup2.value
                }, _toDisplayString(ButtonText.value), 9, _hoisted_69),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: resetAll,
                  disabled: !canUseGroup2.value
                }, _toDisplayString(ButtonText2.value), 9, _hoisted_70)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})